// use the following structure
//
// <div class="show-more"  data-show-more-mobile="true" data-show-more-tablet="true" data-show-more-desktop="false" data-show-more-button="show-more-button-{{ block.id }}" data-show-more-height="140">Text</div>
// <div class="show-more-button collapsed hidden" id="show-more-button-{{ block.id }}">
//   <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path class="show-more-arrow" d="M6 12.6666L6 0.999958M6 12.6666L11 7.66663M6 12.6666L1 7.66662" stroke-linecap="round" stroke-linejoin="round"/>
//   </svg>
//   <span>Expand</span>
// </div>
//
// use  data-show-more-mobile="true" data-show-more-tablet="true" data-show-more-desktop="false", if need to apply the logic for the specified resolution.
// use data-show-more-height="140px" to set the height of the collapsed text. This is required attribute.
// 
// @see example in sections/home-page-collections

(function() {
  const showMoreList = document.querySelectorAll('.show-more');
  const textExpand = "Expand";
  const textCollapse = "Collapse";
  
  const showMoreClick = function(event) {
    event.stopPropagation();
    event.preventDefault()
    
    let showMoreButton = event.target;
  
    if(!showMoreButton.classList.contains('show-more-button')) {
      showMoreButton = showMoreButton.closest('.show-more-button');
    }
  
    if(!showMoreButton) {
      return;
    }
  
    const showMoreButtonId = showMoreButton.getAttribute('id');
  
    if(!showMoreButtonId) {
      return;
    }
    
    const showMoreRelatedBlock = document.querySelector(`.show-more[data-show-more-button="${showMoreButtonId}"]`);
  
    if(!showMoreRelatedBlock) {
      return;
    }
    
    const showMoreCollapsedHeight = showMoreRelatedBlock.dataset.showMoreHeight;
    const showMoreFullHeight = showMoreRelatedBlock.scrollHeight;
    const showMoreButtonText = showMoreButton.querySelector(`span`);
  
    if(showMoreRelatedBlock.classList.contains('collapsed')) {
      showMoreRelatedBlock.style.height = `${showMoreFullHeight}px`;
      showMoreButton.classList.remove('collapsed');
      showMoreButtonText.textContent = textCollapse;
      setTimeout(() => {
        showMoreRelatedBlock.classList.remove('collapsed');
      }, 500);
    }
    else {    
      showMoreButton.classList.add('collapsed');
      showMoreRelatedBlock.classList.add('collapsed');
      showMoreRelatedBlock.style.height = `${showMoreCollapsedHeight}px`;
      showMoreButtonText.textContent = textExpand;
    }
  };
  
  const init = function(event) {
    const isMobile = document.body.dataset.isMobile;
    const isTablet = document.body.dataset.isTablet;
    const isDesktop = document.body.dataset.isDesktop;
    
    showMoreList.forEach(item => {
      const showMoreMobile = item.dataset.showMoreMobile;
      const showMoreTablet = item.dataset.showMoreTablet;
      const showMoreDesktop = item.dataset.showMoreDesktop; 
      const showMoreButtonId = item.dataset.showMoreButton;
      const showMoreCollapsedHeight = parseInt(item.dataset.showMoreHeight);
      const showMoreDynamicInit = item.dataset.showMoreDynamicInit;
  
      if(!showMoreButtonId || !showMoreCollapsedHeight) {
        return;
      }

      if(showMoreDynamicInit === 'true' && item.offsetHeight <= showMoreCollapsedHeight) {
        return;
      }
  
      const showMoreButton = document.querySelector(`#${showMoreButtonId}`);
  
      if(!showMoreButton) {
        return;
      }
  
      const showMoreButtonText = showMoreButton.querySelector(`span`);
  
      if(
        (showMoreMobile === 'false' && isMobile === 'true') ||
        (showMoreTablet === 'false' && isTablet === 'true') ||
        (showMoreDesktop === 'false' && isDesktop === 'true')
      ) {
        showMoreButton.removeEventListener('click', showMoreClick, true);
        showMoreButton.classList.add('hidden');
        showMoreButton.classList.add('collapsed');
        showMoreButtonText.textContent = textExpand;
  
        item.classList.remove('collapsed');
        item.style.removeProperty('height');
        return;
      }
  
      showMoreButton.classList.remove('hidden');
  
      if(!item.classList.contains('collapsed')) {
        item.classList.add('collapsed');
      }
  
      if(!showMoreButton.classList.contains('collapsed')) {
        showMoreButton.classList.add('collapsed');
        showMoreButtonText.textContent = textExpand;
      }
  
      item.style.height = `${showMoreCollapsedHeight}px`;
  
      showMoreButton.removeEventListener('click', showMoreClick, true);
      showMoreButton.addEventListener('click', showMoreClick, true);
    });
  };
  
  setTimeout(init, 500);
  
  let runEvent;
  window.addEventListener('resize', function(){
    clearTimeout(runEvent);
    runEvent = setTimeout(init, 100);
  }, true);
})();